/**
 * Feature flags — controlled by environment variables.
 * Vite statically inlines import.meta.env at build time, so dead-code elimination
 * strips disabled features entirely from the production bundle.
 *
 * To enable a feature locally, set the var in .env and restart the dev server.
 * Both default to false until tax/legal setup is complete.
 */
export const FLAGS = {
  ads: import.meta.env.VITE_ADS_ENABLED === 'true',
  subscriptions: import.meta.env.VITE_SUBSCRIPTIONS_ENABLED === 'true',
  // Injected by vite.config.ts `define` from the single CAPACITOR switch
  // (plan §5, N2) — never set by hand. On web it is the constant `false`,
  // so every `if (FLAGS.nativeIOS)` branch, and the `await import('@capacitor/…')`
  // inside it, is dead code that Rollup removes before it ever reaches the
  // no-native-in-web gate.
  nativeIOS: import.meta.env.VITE_NATIVE_IOS === 'true',
} as const;

/**
 * DECK SYSTEM — HIDDEN (not removed)
 *
 * The entire deck infrastructure remains intact: database schema, RLS policies,
 * store slices, types, API layer, and card_count triggers. Cards are still
 * assigned to a deck_id (auto-created default deck per language pair).
 *
 * The UI is hidden because the single-deck experience is simpler and decks
 * added organizational overhead without clear user value at current scale.
 *
 * To re-enable: set this to false and search "DECK_HIDDEN" for all hidden surfaces.
 */
export const DECK_SYSTEM_HIDDEN = true;
